import type { StoreCollection } from "@/lib/store-collections";

/** Tomorrow Co: the owner's recovery apparel line, one of the store's collections, with its own
 *  branded page and footer at /shop/tomorrow-co. The page address is a stable identifier; the
 *  display name comes from the collection record the owner edits in the CRM. */
export const TOMORROW_SLUG = "tomorrow-co";

/** The owner's words for the Tomorrow Co page, verbatim (design doc, 2026-11-04). */
export const TOMORROW_COPY = {
  headline: "Wear Hope Forward.",
  donation:
    "Independent recovery apparel for people building a brighter tomorrow — with 50% of net profits donated to support local recovery services.",
  disclaimer: "Independent brand, not affiliated with or endorsed by Alcoholics Anonymous (AA).",
  mission:
    "To create high-quality, recovery-inspired apparel that brings hope, builds connection, and helps fund local recovery services in our communities.",
  callout: "50% of net profits donated to support local recovery services.",
  emptyState: "The first pieces are on their way.",
} as const;

export function tomorrowNames(name: string): { eyebrow: string; wordmark: string; title: string } {
  return {
    eyebrow: `${name} · Recovery apparel`,
    wordmark: name.toUpperCase(),
    title: `${name} — Recovery Apparel | OddStack`,
  };
}

/** The seed row (migration 20261104130000). Used only when the collections table cannot be read
 *  at build time, so Tomorrow Co's page still builds. */
export const TOMORROW_FALLBACK: StoreCollection = {
  slug: TOMORROW_SLUG,
  name: "Tomorrow Co",
  cardLine: "THE JOURNEY",
  spotlightLine: "THE ROAD FORWARD",
  description: "One day at a time. Designs celebrating progress, resilience, and the journey forward.",
  nextUpLine: "A little optimism for whatever comes next.",
  tileText: "ONE DAY AT A TIME ✳",
  glyph: "✳",
  accent: "#00d99c",
  sortOrder: 1,
  isFeatured: true,
  isNextUp: true,
};
